import * as yup from "yup";
import { validarCpf } from "../../core/utils/validarCpf";
import { validarCnpj } from "../../core/utils/validarCnpj";
import { validarTelefone } from "../../core/utils/validarTelefone";
import { IndicadorInscricaoEstadual, TipoPessoaCliente } from "../interface/ICliente";

export const clienteSchema = yup.object().shape({
  nome: yup.string().required("O nome é obrigatório").max(50, "O nome não pode ter mais que 50 caracteres"),
  observacao: yup.string().max(50, "A observação não pode ter mais que 50 caracteres"),
  telefone: yup.string().test('telefone', 'Telefone inválido', (value) => validarTelefone(value, false)),
  email: yup.string().email("Endereço de e-mail inválido"),
  cpf: yup.string().test('cpf', 'CPF inválido', (value) => validarCpf(value, false)),

  // Dados fiscais — só fazem diferença quando o cliente é destinatário de NF-e.
  tipoPessoa: yup.string(),
  razaoSocial: yup.string().max(120, "A razão social não pode ter mais que 120 caracteres"),
  cnpj: yup.string()
    .when('tipoPessoa', {
      is: TipoPessoaCliente.JURIDICA,
      then: (schema) => schema
        .required("O CNPJ é obrigatório para pessoa jurídica")
        .test('cnpj', 'CNPJ inválido', (value) => validarCnpj(value, true)),
      otherwise: (schema) => schema.test('cnpj', 'CNPJ inválido', (value) => validarCnpj(value, false)),
    }),
  indicadorInscricaoEstadual: yup.string(),
  inscricaoEstadual: yup.string()
    .when('indicadorInscricaoEstadual', {
      is: IndicadorInscricaoEstadual.CONTRIBUINTE,
      then: (schema) => schema.required("A inscrição estadual é obrigatória para contribuintes do ICMS"),
      otherwise: (schema) => schema,
    }),
});
